<template>
  <scout-topic-panel
    :title="title"
    name="reservation"
    :tooltip="tooltip"
  >
    <router-link
      v-if="!isFutureContract(contractId)"
      :to="{ name: 'scoutReservation', params: { contractId: contractId , jobId: jobId } }"
      class="pega-text-link"
    >
      <span
        data-test="link-text"
        class="boss-scoutandlike-text"
      ><span class="wrap-block">{{ reservationCount }}件</span><span class="wrap-block">({{ reservationUserCount }}名)</span></span>
    </router-link>
  </scout-topic-panel>
</template>

<script>
import ScoutTopicPanel from '@/components/atoms/ScoutTopicPanel'
import { mapGetters } from 'vuex'

export default {
  components: { ScoutTopicPanel },
  props: {
    jobId: {
      type: Number,
      required: true
    },
    contractId: {
      type: Number,
      required: true
    },
    reservationCount: {
      validator: prop => typeof prop === 'number' || prop === '...',
      default: '...'
    },
    reservationUserCount: {
      validator: prop => typeof prop === 'number' || prop === '...',
      default: '...'
    }
  },
  computed: {
    ...mapGetters([
      'isSendScout'
    ]),
    ...mapGetters('contracts', [
      'isFutureContract'
    ]),
    title () {
      return `スカウト予約の確認${this.isSendScout ? '・編集' : ''}`
    },
    tooltip () {
      return `スカウト予約確認${this.isSendScout ? '、編集、削除' : ''}ができます。`
    }
  }
}
</script>
